<template>
    <v-container fluid>
        <activation-form
            :model="model"
            :titlePrefix="$t('forms.title_prefix.add')"
            @saved="saved"
        />
    </v-container>
</template>

<script>
import ActivationForm from './Form'
import Activation from '@/models/Activation'

export default {
    components: {
        ActivationForm,
    },

    data: () => {
        return {
            model: new Activation(),
        }
    },

    methods: {
        saved() {
            this.$router.go(-1)
        },
    },
}
</script>

<style></style>
